export default {
    book_now: 'Rezerviši sada',
    minimum_age: 'Samo preko {age} god.',
    excess_liability: 'Povećana odgovornost',
    security_deposit: 'Depozit',
    fuel_policy: 'Smjernice za gorivo',
    like_for_like: 'Lajk za lajk',
    full_to_full: 'Sipati gorivo u skladu sa potrošnjom',
    miles_per_rental: '{mileage} besplatnih milja po iznajmljivanju',
    km_per_rental: '{mileage} besplatnih kilometara po iznajmljivanju',
    unlimited_mileage: 'Neograničene milje',
    unlimited_mileage_km: 'Neograničena kilometraža',
    non_amendable: 'Ne može se izmijeniti',
    non_refundable: 'Refundacije nisu moguće',
    free_cancellation_until: 'Besplatno otkazivanje do',
    cancellation_in_line_with: 'Otkazivanje u skladu sa',
    tcs: 'Odredbe i uslovi',
    free_extras_on_collection: 'Dva besplatna opciona dodatka po preuzimanju',
    glass_and_tyres_covered: 'Staklo i gume su obuhvaćeni',
    number_of_passengers: 'Broj putnika',
    number_of_bags: 'Količina prtljaga',
    fuel_type: 'Vrsta goriva',
    co2: 'CO2',
    aircon: 'Klima-uređaj',
    transmission: 'Mjenjač',
    book_type: 'Rezerviši {type}',
    debit_card_deposit: 'Debitna kartica prihvaćena za depozite',
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/me/quotes/price_card.js